import { MOVE_TO_WISHLIST_REQUEST, MOVE_TO_WISHLIST_SUCCESS, MOVE_SOLD_OUT_TO_WISHLIST_SUCCESS, MOVE_TO_WISHLIST_ERROR } from '../constants/ActionTypes'
import type GenericAction from './types/genericAction.types'

type IsMovingToWishlistAction = GenericAction<
    typeof MOVE_TO_WISHLIST_REQUEST | typeof MOVE_TO_WISHLIST_SUCCESS | typeof MOVE_SOLD_OUT_TO_WISHLIST_SUCCESS | typeof MOVE_TO_WISHLIST_ERROR,
    { partNumber: number }
>

type State = Record<string, boolean>

const isMovingToWishlist = (state: State = {}, action: IsMovingToWishlistAction) => {
    switch (action.type) {
        case MOVE_TO_WISHLIST_REQUEST:
            return { ...state, [action.partNumber.toString()]: true }

        case MOVE_TO_WISHLIST_SUCCESS:
        case MOVE_SOLD_OUT_TO_WISHLIST_SUCCESS:
        case MOVE_TO_WISHLIST_ERROR: {
            /* eslint no-unused-vars: ["error", { "varsIgnorePattern": "ignore" }] */
            const { [action.partNumber.toString()]: ignore, ...nextState } = state
            return nextState
        }

        default:
            return state
    }
}

export default isMovingToWishlist
